import React, { useEffect } from 'react';
import { Spinner } from '@acorns/web-components';
import { LOGIN_FLOW_STATES } from '../types';
import { Type, write } from '../../../utils/auth';
import { StyledButton, StyledModal, StyledTitle, StyledTextInput } from '../components';
import { useChallengeForm, CHALLENGE_RESULT } from './useChallengeForm';
import { useResendChallengeMutation } from './useResendChallengeMutation'; // Ensuring userCreds is required

var TwoFactorForm = function TwoFactorForm(_ref) {
  var onBack = _ref.onBack,
      onClose = _ref.onClose,
      onStateChange = _ref.onStateChange,
      show = _ref.show,
      userCreds = _ref.userCreds;

  var _useChallengeForm = useChallengeForm(userCreds),
      errors = _useChallengeForm.errors,
      data = _useChallengeForm.data,
      loading = _useChallengeForm.loading,
      handleChange = _useChallengeForm.handleChange,
      handleSubmit = _useChallengeForm.handleSubmit,
      result = _useChallengeForm.result,
      values = _useChallengeForm.values;

  var _useResendChallengeMu = useResendChallengeMutation((userCreds === null || userCreds === void 0 ? void 0 : userCreds.challengeId) || ''),
      challengeLoading = _useResendChallengeMu.loading,
      resendChallengeMutation = _useResendChallengeMu.resendChallengeMutation; // State management


  useEffect(function () {
    if (CHALLENGE_RESULT.success === result && data) {
      onStateChange(LOGIN_FLOW_STATES.closed);
      onClose();
    } else if (CHALLENGE_RESULT.failure === result) {
      onStateChange(LOGIN_FLOW_STATES.error);
    }
  }, [result]);
  /**
   * Write token to localhost cookie whenever we get data back.
   */

  useEffect(function () {
    if ((data === null || data === void 0 ? void 0 : data.__typename) === 'AuthSession') {
      write(Type.token, data.token);
    }
  }, [data]);
  return /*#__PURE__*/React.createElement(StyledModal, {
    onRequestClose: onClose,
    isOpen: show,
    isTrapModal: true,
    accessibilityProperties: {
      labelledBy: 'challenge-form-title'
    }
  }, /*#__PURE__*/React.createElement(StyledTitle, {
    id: "challenge-form-title"
  }, "Enter Verification Code"), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(StyledTextInput, {
    autoFocus: true // eslint-disable-line
    ,
    error: !!errors.challengeAnswer,
    errorText: errors.challengeAnswer,
    id: "challengeAnswer",
    name: "challengeAnswer",
    label: "Verification Code",
    onChange: handleChange,
    type: "text",
    value: values.challengeAnswer
  }), /*#__PURE__*/React.createElement(StyledButton, {
    buttonType: "submit",
    disabled: !!errors.challengeAnswer,
    onPress: handleSubmit
  }, loading ? /*#__PURE__*/React.createElement(Spinner, {
    height: 25,
    width: 25
  }) : 'Verify'), /*#__PURE__*/React.createElement(StyledButton, {
    styleType: "light",
    secondary: true,
    onPress: resendChallengeMutation
  }, challengeLoading ? /*#__PURE__*/React.createElement(Spinner, {
    height: 25,
    width: 25
  }) : 'Resend'), /*#__PURE__*/React.createElement(StyledButton, {
    secondary: true,
    onPress: onBack
  }, "Go back")));
};

export { TwoFactorForm };